import MandantStorage from "../storage/mandant-storage";
import CONFIG from '../config';

import {
  FETCH_MANDANT_DATA,
  FETCH_MANDANT_LOGO,
  NEW_MANDANT_DATA,
  FETCH_MANDANT_ORDER_LIMIT
} from "../actions/types/mandant-types";

export default function reducer(state = MandantStorage, action) {
  switch (action.type) {
    case FETCH_MANDANT_DATA: {
      let newState = { ...state };
      newState.setMandantData(action.mandantdaten);
      //save image url in mandantstorage
      //read mandant Id
      //generate logo url
      //generate contact url
      //
      if (CONFIG.themeClasses && CONFIG.themeClasses[newState.theme]) {
        Array.from(document.getElementsByTagName('body')).forEach(body => {
          if (body && body.classList) {
            Object.keys(CONFIG.themeClasses).forEach(t => {
              body.classList.remove(CONFIG.themeClasses[t]);
            });
            body.classList.add(CONFIG.themeClasses[newState.theme]);
          }
        });
      }
      return newState;
    }
    case FETCH_MANDANT_LOGO: {
      let newState = { ...state };
      newState.setMandantLogoImage(action.logo);
      return newState;
    }
    case NEW_MANDANT_DATA: {
      let newState = { ...state };
      let mandant = {
        theme: newState.theme,
        lieferadresseKz: newState.lieferadresseKz,
        searchLieferadresseAktiv: newState.searchLieferadresseAktiv,
        ablieferadresseAnkauf: newState.ablieferadresseAnkauf,
        searchAblieferadresseAktiv: newState.searchAblieferadresseAktiv,
        abwAdresseBsErlaubt: newState.abwAdresseBsErlaubt,
        yesVerifiedAdresseKz: newState.yesVerifiedAdresseKz,
        schwellenwert: newState.schwellenwert,
        minOrderValueFiliale: newState.minOrderValueFiliale,
        fileList: [],
        mandantFooterList: [],
        headeralt1: "",
      };
      if (action.mandantdaten && action.mandantdaten.mandant) {
        mandant = {
          ...mandant,
          ...action.mandantdaten.mandant
        };
      }
      newState.setMandantData({ mandant });
      return newState;
    }
    case FETCH_MANDANT_ORDER_LIMIT: {
      let newState = { ...state };
      if (action.orderLimit && action.orderLimit.mandantOrderLimit) {
        newState.setOrderLimit(action.orderLimit.mandantOrderLimit);
      }
      return newState;
    }
    default:
      return state;
  }
}
